module.exports = __webpack_public_path__ + "img/0220809172759.7b5de899.jpg";